import React, { Component } from 'react'
import propTypes from 'prop-types'
import Slider from 'rc-slider'

import styles from './styles.scss'

class Opacity extends Component {
  state = {
    opacity: 1
  }

  componentDidMount() {
    const { opacity } = this.props
    this.setState({ opacity })
  }

  render() {
    const { opacity } = this.state
    const { onChange } = this.props

    return (
      <div className={styles['wrapper-opacity']}>
        <Slider
          min={0}
          max={100}
          value={opacity * 100}
          trackStyle={{ backgroundColor: '#2962FF', height: '11px' }}
          handleStyle={{
            width: '20px',
            height: '20px',
            backgroundColor: '#2962FF',
          }}
          railStyle={{ backgroundColor: '#D8DCE5', height: '11px' }}
          onChange={value => this.setState({ opacity: value / 100 })}
          onAfterChange={value => onChange(value / 100)}
        />
        <input
          min={0}
          max={100}
          maxLength={3}
          value={~~(opacity * 100)}
          onChange={({ target }) => this.setState({ opacity: target.value / 100 }, onChange(opacity))}
        />
      </div>
    )
  }
}


Opacity.propTypes = {
  opacity: propTypes.number
}

Opacity.defaultProps = {
  opacity: 1
}

export default Opacity



// WEBPACK FOOTER //
// ./src/components/Opacity/index.js